export default "__VITE_ASSET__BabveAO0__"